module.exports = "/images/bannerFour-mobile.jpg";